<template>
  <div>
    <div class="super_container">

      <!-- Header -->




      <!-- Home -->



      <div class="contact" style="min-height: calc(100vh - 790px); padding-top: 150px;">
        <div class="container">
          <div class="row">

            <!-- Contact Info -->
            <div class="col-lg-12">
              <div class="contact_title">ПОЛИТИКА COOKIES</div>
              <div class="contact_text">


                <p style="text-align: center;"><strong><span >ПОЛИТИКА </span></strong><strong><span >COOKIES</span></strong></p>
                <p><span >&nbsp;</span></p>
                <p><span >Спасибо за посещение Leeloo.ai («Веб-сайт»). Эта политика cookies («Политика» и / или «Политика cookies») распространяется на Веб-сайт. Используя Веб-сайт, вы соглашаетесь с нашим использованием файлов cookies и других технологий отслеживания в соответствии с настоящей Политикой. Если вы не согласны с нашим использованием cookies и других технологий отслеживания, вы должны соответствующим образом настроить параметры своего браузера или не использовать Политику. Однако, если вы отключите cookies, которые мы используем, это может повлиять на работу пользователя на Веб-сайте и использование наших услуг. </span></p>
                <p><span >&nbsp;</span></p>
                <p><strong><span >Что такое Cookies?</span></strong></p>
                <p><span >Файл cookies представляет собой небольшой фрагмент данных, который часто включает уникальный идентификатор, который отправляется в браузер вашего компьютера с сервера веб-сайта и хранится на жестком диске вашего компьютера. Каждый веб-сайт или сторонний поставщик услуг, используемый веб-сайтом, может отправить свой собственный файл cookies в ваш браузер, если позволяют его параметры, но (для защиты вашей конфиденциальности) ваш браузер разрешает только веб-сайту или стороннему поставщику услуг получать доступ к файлам cookies, которые он уже отправил вам, а не&nbsp; к cookies, отправленным вам другими сайтами или другими сторонними поставщиками услуг. Файл cookies будет содержать некоторую анонимную информацию, такую как уникальный идентификатор и имя сайта, а также некоторые цифры и номера. Это позволяет веб-сайту запоминать такие вещи, как ваши настройки параметров. Файл cookies может быть сессионным, то есть файлом cookies, который остается в вашем браузере, когда вы заходите на определенный веб-сайт, а затем исчезает при закрытии браузера или может быть постоянным файлом cookies, который остается в вашем браузере в течение определенного периода времени.</span></p>
                <p><span >Подробнее о файлах cookies можно узнать по ссылке ниже: https://support.google.com/accounts/answer/61416?hl=ru</span></p>
                <p><span >&nbsp;</span></p>
                <p><strong><span >Как и почему мы используем Cookies?</span></strong></p>
                <p><span >Мы используем файлы cookies для улучшения использования и функциональности Веб-сайта и наших Услуг и для лучшего понимания того, как посетители используют Веб-сайт, а также инструменты и услуги, предлагаемые на нем. Файлы cookies помогают нам адаптировать Веб-сайт к вашим личным потребностям, улучшить удобство использования, получать обратную связь с клиентами и связаться с вами в другом месте в интернете.</span></p>
                <p><span >&nbsp;</span></p>
                <p><strong><span >Какие типы файлов cookies могут использоваться на Веб-сайте</span></strong></p>
                <p><span >На Веб-сайте мы можем использовать следующие типы файлов cookies:</span></p>
                <p><span >Сессионные cookies</span></p>
                <p><span >Сессионные файлы cookies - это временные файлы cookies, которые удаляются при закрытии браузера. Когда вы перезагружаете свой браузер и возвращаетесь на сайт, создавший этот файл cookies, сайт будет рассматривать вас как нового посетителя.</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >Постоянные cookies</span></p>
                <p><span >Постоянные файлы cookies остаются в вашем браузере до тех пор, пока вы не удалите их вручную или пока ваш браузер не удалит их в зависимости от периода времени, установленного в файле cookies. Эти cookies распознают вас как возвращающегося посетителя.</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >Cookies, которые отправляют нам информацию</span></p>
                <p><span >Это файлы cookies, которые мы установили на Веб-сайте, и они могут быть прочитаны только на этом Веб-сайте. Они известны как «основной файл cookies».</span></p>
                <p><span >Другие аналогичные технологии</span></p>
                <p><span >Другие технологии отслеживания, включая IP-адреса, лог-файлы и веб-маяки, которые также помогают нам адаптировать наш Веб-сайт к вашим личным потребностям.</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >IP-адреса</span></p>
                <p><span >IP-адрес - это номер, который используется компьютерами в сети для идентификации вашего компьютера при каждом входе в Интернет. Мы можем записывать IP-адреса для следующих целей: (I) устранения технических проблем, (II) поддержки безопасности Веб-сайта (III) лучшего понимания, как используется наш Веб-сайт, и (IV) лучшей адаптации контента к вашим потребностям в зависимости от страны, в которой вы находитесь.</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >Лог-файлы</span></p>
                <p><span >Мы (или третьи лица от нашего имени) можем собирать информацию в виде файлов журналов, которые записывают активность Веб-сайта и собирают статистику о посещениях пользователя. Эти записи генерируются анонимно и помогают нам собирать (среди прочего) (I) тип браузера и операционную систему пользователя, (II) информацию о сеансе пользователей (например, URL-адрес, с которого они пришли, дату и время, которое они посетили наш Веб-сайт и страницы, которые они просматривали на нашем Веб-сайте и как долго), и (III) другие аналогичные данные навигации или посещения. </span></p>
                <p><span >&nbsp;</span></p>
                <p><span >Веб-маяки</span></p>
                <p><span >Мы можем использовать веб-маяки (или пустые GIF-изображения) на Веб-сайте. Веб-маяки (также известные как «веб-жучки») представляют собой небольшие строки кода, которые предоставляют способ доставки графического изображения на веб-страницу с целью передачи данных обратно нам. Информация, собранная с помощью веб-маяков, может включать информацию о том, как пользователь отвечает на кампанию электронной почты (например, время открытия электронной почты, где пользователь ссылается на электронную почту и т. д.). Мы используем информацию веб-маяка для различных целей, включая отчет о трафике сайта, уникальные подсчеты посетителей, аудит рекламы и электронной почты, отчетность, а также персонализация.</span></p>
                <p><span >&nbsp;</span></p>
                <p><strong><span >Управление файлами cookies / параметрами</span></strong></p>
                <p><span >Вы должны убедиться, что ваш компьютер настроен на то, согласны ли вы принять файлы cookies или нет. Вы можете настроить браузер так, чтобы он предупреждал вас, прежде чем принимать файлы cookies, или вы можете просто отказаться от них. Вам не нужно иметь файлы cookies для использования или навигации по многим частям Веб-сайта, хотя вы можете не иметь доступа ко всем функциям на Веб-сайте, если вы это сделаете. Посмотрите кнопку «Справка» в вашем браузере для того, как можно это сделать. Помните, что если вы используете разные компьютеры в разных местах, вам необходимо убедиться, что каждый браузер настроен в соответствии с вашими предпочтениями в cookies.</span></p>
                <p><span >Поскольку веб-маяки являются частью веб-страницы, невозможно «отказаться» от них, но вы можете сделать их неэффективными, отказавшись от файлов cookies, которые они установили.</span></p>
                <p><span >&nbsp;</span></p>
                <p><strong><span >Блокирование или удаление вашей личной информации</span></strong></p>
                <p><span >Большинство браузеров позволяют отказаться от приема файлов cookies. Эти ссылки объясняют, как вы можете управлять cookies через ваш браузер - помните, что если вы отключите файлы cookies в своем браузере, то эти настройки применимы ко всем сайтам, а не только к нашему:</span></p>
                <p><span >&nbsp;</span></p>
                <ul>
                  <li><span > Internet Explorer http://support.microsoft.com/kb/278835 (эта страница ссылается на дополнительную информацию для разных версий IE - мобильная версия находится на</span></li>
                </ul>
                <p><span >www.microsoft.com/windowsphone/en-us/howto/wp7/web/changing-privacy-and-other-browser-settings.aspx)</span></p>
                <ul>
                  <li><span > Chrome: http://support.google.com/chrome/bin/answer.py?hl=ru&amp;hl=ru&amp;answer=95647.</span></li>
                  <li><span > Safari: http://docs.info.apple.com/article.html?path=Safari/5.0/en/9277.html (или http://support.apple.com/kb/HT1677 для мобильных версий)</span></li>
                  <li><span > Firefox: http://support.mozilla.org/en-US/kb/Enabling%20and%20disabling%20cookies</span></li>
                  <li><span > Opera: http://www.opera.com/browser/tutorials/security/privacy/</span></li>
                </ul>
                <p><span >&nbsp;</span></p>
                <p><span >Однако, блокирование всех файлов cookies будет иметь негативное влияние на удобство использования многих веб-сайтов. Вы также можете удалить файлы cookies, уже сохраненные на вашем компьютере, в соответствии с инструкциями вашего браузера. Опять же, это может отрицательно повлиять на удобство использования многих веб-сайтов.</span></p>
                <p><span >Если вы хотите отказаться от cookies Google Analytics, сделайте это, нажав на ссылки: Google Analytics: https://tools.google.com/dlpage/gaoptout.</span></p>
                <p><span >Подробнее об удалении файлов cookies можно узнать на странице </span><a href="https://support.google.com/accounts/answer/32050?hl=ru"><span style="font-size: 12.0pt; line-height: 107%; font-family: 'Times New Roman','serif'; color: #1155cc;">https://support.google.com/accounts/answer/32050?hl=ru</span></a><span >.</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >&nbsp;</span></p>
                <p><span >&nbsp;</span></p>


              </div>


            </div>

          </div>

        </div>
      </div>





    </div>
  </div>



</template>
<script>
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        user: {
          company: '',
          username: '',
          email: '',
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          region: '',
          country: '',
          aboutMe: ``
        },

        userSignup: {
          username:{ value:'', valid:true, error:''},
          email:{ value:'', valid:true, error:''},
          firstName:{ value:'', valid:true, error:''},
          lastName:{ value:'', valid:true, error:''},
          password:{ value:'', valid:true, error:''},
          passwordRepeat:{ value:'', valid:true, error:''},
        },
        userLogin: {
          email:{ value:'', valid:true, error:''},
          password:{ value:'', valid:true, error:''},
        },
        userSignupErrors:[],
        userLoginErrors:[]
      }
    },
    computed: {
      // isLoading() {
      //   return this.$store.getters['tournament/isLoading'];
      // },
      hasErrorSignup() {
        return this.$store.getters['user/hasErrorSignup'];
      },
      errorSignup() {
        return this.$store.getters['user/errorSignup'];
      },
      errorLogin() {
        return this.$store.getters['user/errorLogin'];
      },

      hasErrorLogin() {
        return this.$store.getters['user/hasErrorLogin'];
      },


    },
    watch: {
      // whenever question changes, this function will run
      errorLogin: function (newValue, oldValue) {
        console.log('change errorLogin', newValue);
        // console.log('newValue.messages', newValue.messages);
        if(newValue != undefined && newValue.messages != undefined){
          this.userLoginErrors = newValue.messages;
        }else{
          this.userLoginErrors = '';
        }

        console.log('userLoginErrors', this.userLoginErrors);
      },
      // whenever question changes, this function will run
      errorSignup: function (newValue, oldValue) {
        if(newValue.messages != undefined){
          this.userSignupErrors = newValue.messages;
        }
        console.log(newValue);
        if(newValue.fields != undefined){
          if(newValue.fields.includes('username')){
            this.userSignup.username.valid = false;
          }else{
            this.userSignup.username.valid = true;
          }

          if(newValue.fields.includes('email')){
            this.userSignup.email.valid = false;
          }else{
            this.userSignup.email.valid = true;
          }

          if(newValue.fields.includes('firstName')){
            this.userSignup.firstName.valid = false;
          }else{
            this.userSignup.firstName.valid = true;
          }

          if(newValue.fields.includes('lastname')){
            this.userSignup.lastName.valid = false;
          }else{
            this.userSignup.lastName.valid = true;
          }

          if(newValue.fields.includes('password')){
            this.userSignup.password.valid = false;
          }else{
            this.userSignup.password.valid = true;
          }

          if(newValue.fields.includes('passwordRepeat')){
            this.userSignup.passwordRepeat.valid = false;
            this.userSignup.password.valid = false;
          }else{
            this.userSignup.passwordRepeat.valid = true;
            this.userSignup.password.valid = true;
          }


        }

      }
    },
    methods: {
      updateProfile () {
        alert('Your data: ' + JSON.stringify(this.user))
      },
      toRegistration(){
        this.$router.replace({ path: `/signUp` }) // -> /user/123
      },
      userSignupForm(){
        let params = {username:this.userSignup.username.value, email:this.userSignup.email.value, password:this.userSignup.password.value, passwordRepeat:this.userSignup.passwordRepeat.value, fname:this.userSignup.firstName.value, lname:this.userSignup.lastName.value};
        this.$store.dispatch('user/createUser', params);
        // alert('Your data: ' + JSON.stringify(this.userSignup));
      },
      userLoginForm(){
        let params = { email:this.userLogin.email.value, password:this.userLogin.password.value};
        let objthis =  this;
        this.$store.dispatch('user/loginUser', params).then(function (){

          location.href = '/user/';
          // objthis.$store.dispatch('user/fetchUserCurrent').then(()=>objthis.$router.replace({ path: `/user/` }));




        }) ;// -> /user/123);
        // alert('Your data: ' + JSON.stringify(this.userSignup));
      },

      focusFieldSignup(field){
        if(field =='username'){
          this.userSignup.username.valid = true;
        }

        if(field =='email'){
          this.userSignup.email.valid = true;
        }

        if(field =='firstName'){
          this.userSignup.firstName.valid = true;
        }

        if(field =='lastname'){
          this.userSignup.lastName.valid = true;
        }

        if(field =='password'){
          this.userSignup.password.valid = true;
        }

        if(field =='passwordRepeat'){
          this.userSignup.passwordRepeat.valid = true;
        }

        this.userSignupErrors = '';
      }
    }
  }

</script>


<style scoped>

  /*@import "../assets/home/styles/bootstrap-4.1.2/bootstrap.min.css";*/
  /*@import "../assets/home/plugins/font-awesome-4.7.0/css/font-awesome.min.css";*/
  /*@import "../assets/home/styles/main_styles.css";*/
  /*@import "../assets/home/styles/main_styles.css";*/
  /*@import "../assets/home/styles/contact.css";*/
  /*@import "../assets/home/styles/responsive.css";*/
  /*@import "../assets/home/plugins/OwlCarousel2-2.2.1/animate.css";*/
</style>
